// The frame after sign-in, in App admin's layout: the left menu, the top bar and the page (the only part that
// scrolls). Someone without 2-step sees the banner offering it; on the mock API the Test tools button is in the
// corner.
import type { ReactNode } from 'react'
import { PERMISSION } from '@/constants/permissions'
import { useMe } from '../session'
import { TestToolsButton } from '../test-tools/TestToolsButton'
import { Sidebar } from './Sidebar'
import { TopBar } from './TopBar'
import { TwoStepBanner } from './TwoStepBanner'

export function Shell({ children }: { children: ReactNode }) {
  const { can } = useMe()
  return (
    <div className="flex h-screen w-full overflow-hidden bg-canvas dark:bg-canvas-dark">
      <Sidebar />
      <div className="flex h-full min-w-0 flex-1 flex-col">
        <TopBar />
        <main className="flex-1 overflow-y-auto overflow-x-hidden">
          <div className="mx-auto max-w-[1400px] p-3 sm:p-4 lg:p-5">
            <TwoStepBanner />
            {children}
          </div>
        </main>
      </div>
      <TestToolsButton signedIn canAnswerMeta={can(PERMISSION.channelsEdit)} />
    </div>
  )
}
